import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './ConsentRequestsCard.css';
import { CONSENT_REQUESTS_FILTER, CONSENT_REQUESTS_CANCELED } from "../../../reducers/consent/organizationConsents";
import { Badge } from 'reactstrap';
import moment from 'moment';

const CARD_STATUS_COLOR = {
    [CONSENT_REQUESTS_FILTER.PENDING]: "secondary",
    [CONSENT_REQUESTS_FILTER.REJECTED]: "danger",
    [CONSENT_REQUESTS_FILTER.GRANTED]: "success",
    [CONSENT_REQUESTS_FILTER.EXPIRED]: "warning",
    [CONSENT_REQUESTS_FILTER.REVOKED]: "warning",
    [CONSENT_REQUESTS_CANCELED]: "light"
};

const CARD_STATUS_HAS_EXPIRE_TIME = [CONSENT_REQUESTS_FILTER.GRANTED, CONSENT_REQUESTS_FILTER.EXPIRED];

class ConsentRequestsCard extends Component {
    render() {
        if (!_.isNil(this.props.data)) {
            return (
                <div className={"consent-request-card-container " + (this.props.isActive ? "active" : "")} onClick={this.handleClick}>
                    {this.renderContent()}
                </div>
            );
        } else {
            return null;
        }
    }

    renderContent = () => {
        return (
            <div>
                <div className="consent-request-card-last-update">
                    {_.get(this.props.translation, "consents.last_update_label") + ": " + moment(this.props.data.updatedAt).format("L")}
                </div>
                {this.renderJobInfo()}
                <h6 className="consent-request-card-email">{this.props.data.applicant.email}</h6>
                {this.renderRequestCardStatus()}
            </div>
        )
    };

    renderJobInfo = () => {
        return (
            <span>
                {this.props.data.jobDescription.internalReference ?
                    this.props.data.jobDescription.internalReference + " - " + this.props.data.jobDescription.title
                    :
                    this.props.data.jobDescription.title
                }
            </span>
        )
    };

    renderRequestCardStatus = () => {
        return (
            <div className={"consent-request-card-status " + (CARD_STATUS_HAS_EXPIRE_TIME.includes(this.props.data.status) ? "with-expire" : "")}>
                {this.renderRequestsCardDate()}
                <h5>
                    <Badge className={"request-status-badge " + this.props.data.status.toLowerCase()} color={CARD_STATUS_COLOR[this.props.data.status]}>{_.get(this.props.translation, 'consents.status.' + this.props.data.status)}</Badge>
                </h5>
            </div>
        )
    };

    renderRequestsCardDate = () => {
        switch (this.props.data.status) {
            case CONSENT_REQUESTS_FILTER.GRANTED:
                return (
                    <span>
                        {_.get(this.props.translation, "consents.expires_label") + " " + moment(this.props.data.grantedTill).format("L")}
                    </span>
                );
        
            case CONSENT_REQUESTS_FILTER.EXPIRED:
                return (
                    <span className="consent-request-card-expired-status-expire-date">
                        {_.get(this.props.translation, "consents.expired_label") + " " + moment(this.props.data.grantedTill).format("L")}
                    </span>
                );
                    
            default:
                return null;
        }
    }

    handleClick = () => {
        this.props.onSelectConsentRequest(this.props.id);
        this.props.onClick();
    }
}

ConsentRequestsCard.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    isActive: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onSelectConsentRequest: PropTypes.func,
    onClick: PropTypes.func
};

export default ConsentRequestsCard;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestCard/ConsentRequestsCard.js